/**
 * @fileoverview Taskflow - Left Nav component React interface.
 * @author Qiwen Luo (qluo@yext.com)
 */

import {Card} from '/ui/components/card/card';
import * as Types from '/ui/components/taskflow/models';
import {classNames} from '/ui/lib/classnames';

import * as styles from '/ui/components/taskflow/leftNav/leftNav.module.scss';

/**
 * @param {{
 *   sections: !Array<!Types.Section>,
 * }} props
 * @return {React.ReactElement}
 */
export function LeftNav({
  sections,
}) {
  return (
    <div className={styles.container}>
      {
        sections.map((section, index) => {
          return (
            <div key={index}>
              <div className={styles.sectionHeaderContainer}>
                {section.header}
              </div>
              {section.children.map((card, index) => {
                return (
                  <div key={card.id} className={styles.cardWrapper}>
                    <div className={styles.cardContainer}>
                      <Card selected={card.isSelected} onClick={card.onClick} isFullWidth={true} taskFlowStyle={true}>
                        <Card.Body>
                          <div className={styles.cardBodyContainer}>
                            {
                              card.icon
                              ? <span className={styles.cardIcon}>{card.icon}</span>
                              : (
                                <span className={styles.cardBodyPrefix}>
                                  {`${card.index ?? index+1}. `}
                                </span>
                              )
                            }
                            <div className={styles.cardBody}>
                              {card.title}
                              {
                                card.content && <div>{card.content}</div>
                              }
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div
                      className={classNames(
                        styles.partition,
                        index<section.children.length-1 && styles.partitionVisible,
                      )}
                    >
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })
      }
    </div>
  );
}

